import http from './httpService';
import config from './../config.json';

const address = config.api_address + config.api_product;


export const getProductArchive = (params, {signal}) => {
    return http.get(`${address}/archive`, {params, signal});
}

export const getProductInfo = (productId, {signal}) => {
    return http.get(`${address}/productInfo/${productId}`, {signal});
}

export const getProductsForSort = (categoryId, {signal}) => {
    return http.get(`${address}/products-for-sort/${categoryId}`, {signal});
}

export const setProductsPriority = (priorities) => {
    return http.patch(`${address}/priority`, priorities);
}

export const createProduct = (product, params) => {
    return http.post(`${address}`, product, params);
}

export const blockingProduct = (productId) => {
    return http.get(`${address}/blocking/${productId}`);
}

export const updateProduct = (productId, product, params) => {
    return http.patch(`${address}/${productId}`, product, params);
}

export const deleteProduct = (productId) => {
    return http.delete(`${address}/${productId}`);
    
}

export const changeStatusProduct = (productId, info) => {
    return http.patch(`${address}/change-status/${productId}`, info);
    
}

